import { render } from "./FilterMultiSelect.vue?vue&type=template&id=ba874800"
import script from "./FilterMultiSelect.vue?vue&type=script&lang=js"
export * from "./FilterMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__